import Notifier from '../../../libs/Notifier';
import getParentSuperorderChecklistActivities from '../../../modules/activity/application/getParentSuperorderChecklistActivities';
import createApiActivityRepository from '../../../modules/activity/infrastructure/ApiActivityRepository';

const repository = createApiActivityRepository();

export default {
  async getParentSuperorderChecklistActivities({ commit }, superOrderId) {
    try {
      const activities = await getParentSuperorderChecklistActivities(repository, superOrderId);
      commit('SET_PARENT_SUPERORDER_ACTIVITIES', activities);
    } catch (error) {
      Notifier('Ocurrió un error al obtener las actividades de la superorden cancelada.', 'error');
    }
  },
};
